/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { TestimonialItem, getDefaultTestimonials } from '@coursera-web/cds-labs';

import { Grid, PageGridContainer, Typography2, breakpoints } from '@coursera/cds-core';

import OverflowCarousel from 'bundles/front-page/components/overflow-carousel/OverflowCarousel';
import { useRegisterItem } from 'bundles/front-page/components/overflow-carousel/OverflowCarouselProvider';

const styles = {
  title: css`
    margin-bottom: var(--cds-spacing-150);
  `,
  testimonialsGrid: css`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: 1fr;
    gap: var(--cds-spacing-200);

    ${breakpoints.down('sm')} {
      /* 232px is the width of the testimonial item when viewport = 1023px */
      grid-template-columns: repeat(4, minmax(232px, 1fr));
    }
  `,
};

const getTestimonials = () => {
  // TODO: update with final copy and translate it.
  // https://coursera.atlassian.net/browse/MERCH-1786
  return {
    title: 'What our learners say',
    testimonials: getDefaultTestimonials(),
  };
};

const TestimonialItemWrapper = ({ children, index }: { children: React.ReactNode; index: number }) => {
  const registerItem = useRegisterItem();

  return (
    <div
      ref={(node) => {
        if (node && index !== undefined) {
          registerItem?.(index.toString(), node);
        }
      }}
    >
      {children}
    </div>
  );
};

const TestimonialsModuleRedesignRenderer = () => {
  const { title, testimonials } = getTestimonials();

  return (
    <section>
      <PageGridContainer>
        <Grid item xs={12}>
          <Typography2 variant="subtitleLarge" component="h2" css={styles.title}>
            {title}
          </Typography2>
          <OverflowCarousel css={styles.testimonialsGrid}>
            {testimonials.map((testimonial, index) => (
              <TestimonialItemWrapper key={testimonial.name} index={index}>
                <TestimonialItem
                  name={testimonial.name}
                  quote={testimonial.quote}
                  imageSrc={testimonial.imageSrc}
                  learnerSince={testimonial.learnerSince}
                  trackingIndex={index}
                  forceUseDesktopStyles
                />
              </TestimonialItemWrapper>
            ))}
          </OverflowCarousel>
        </Grid>
      </PageGridContainer>
    </section>
  );
};

export default TestimonialsModuleRedesignRenderer;
